import { useEventCallback } from '@shared/utils/hooks/useEventCallback';
import { useEventVenueDialogTelemetry } from '../components/EventVenueDialog/EventVenueDialog.telemetry';
import { EventVenueState } from '../components/EventVenueDialog/useEventVenueDialog';
import { VenueDialogAction } from './useEventVenueDialogReducer';
import { useEventInfo } from '@shared/utils/eventInfo';

export const useVenueDialogTransitions = (dispatch: React.Dispatch<VenueDialogAction>) => {
  const { eventHandle } = useEventInfo();
  const telemetry = useEventVenueDialogTelemetry();

  const callTelemetry = useEventCallback((eventVenueState: EventVenueState) => {
    telemetry.eventVenueDialogStateChanged(eventVenueState, eventHandle);
  });

  const goToCreate = useEventCallback(() => {
    callTelemetry(EventVenueState.create);
    dispatch({ type: 'SET_EVENT_VENUE_STATE', eventVenueState: EventVenueState.create });
  });

  const goToUpdate = useEventCallback(() => {
    callTelemetry(EventVenueState.update);
    dispatch({ type: 'SET_EVENT_VENUE_STATE', eventVenueState: EventVenueState.update });
  });

  const goToIntro = useEventCallback(() => {
    callTelemetry(EventVenueState.intro);
    dispatch({ type: 'SET_EVENT_VENUE_STATE', eventVenueState: EventVenueState.intro });
  });

  const goToFilters = useEventCallback(() => {
    callTelemetry(EventVenueState.filters);
    dispatch({ type: 'SET_EVENT_VENUE_STATE', eventVenueState: EventVenueState.filters });
  });

  const goToHotels = useEventCallback(() => {
    callTelemetry(EventVenueState.hotels);
    dispatch({ type: 'SET_EVENT_VENUE_STATE', eventVenueState: EventVenueState.hotels });
  });

  const goToNoHotels = useEventCallback(() => {
    callTelemetry(EventVenueState.noHotels);
    dispatch({ type: 'SET_EVENT_VENUE_STATE', eventVenueState: EventVenueState.noHotels });
  });

  const goToError = useEventCallback(() => {
    callTelemetry(EventVenueState.error);
    dispatch({ type: 'SET_EVENT_VENUE_STATE', eventVenueState: EventVenueState.error });
  });

  const goToConfirm = useEventCallback(() => {
    callTelemetry(EventVenueState.confirm);
    dispatch({ type: 'SET_EVENT_VENUE_STATE', eventVenueState: EventVenueState.confirm });
  });

  return { goToCreate, goToUpdate, goToIntro, goToFilters, goToHotels, goToError, goToNoHotels, goToConfirm };
};
